import { render, staticRenderFns } from "./MenuNavigator.vue?vue&type=template&id=9ade1c3c&scoped=true"
import script from "./MenuNavigator.vue?vue&type=script&lang=js"
export * from "./MenuNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ade1c3c",
  null
  
)

export default component.exports